function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M36.992,416.569c0,20.078,16.262,36.344,36.34,36.344h118.111  c20.079,0,36.343-16.266,36.343-36.344V271.202c0-20.079-16.264-36.342-36.343-36.342h-58.328c-10.089,0-18.17-8.177-18.17-18.17  c0-3.271,0.815-5.542,0.815-5.542c13.264-43.977,46.785-79.227,89.762-94.852l0.18-0.182c12.997-5.54,22.083-18.445,22.083-33.437  c0-20.077-16.264-36.341-36.343-36.341c-4.906,0-9.536,0.998-13.804,2.723l-1.644,0.64C94.68,81.405,36.992,160.45,36.992,253.03  V416.569z M273.215,416.569c0,20.078,16.262,36.344,36.341,36.344h118.112c20.078,0,36.34-16.266,36.34-36.344V271.202  c0-20.079-16.262-36.342-36.34-36.342h-58.33c-10.088,0-18.169-8.177-18.169-18.17c0-3.362,0.813-5.542,0.813-5.542  c13.267-43.977,46.787-79.227,89.765-94.852l0.18-0.182c12.995-5.54,22.081-18.445,22.081-33.437  c0-20.077-16.262-36.341-36.34-36.341c-4.906,0-9.538,0.998-13.805,2.723l-1.644,0.64C330.903,81.405,273.215,160.45,273.215,253.03  V416.569z",
  fill: "#ffffff",
  fillRule: "evenodd"
});

var SvgQuotes = function SvgQuotes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    enableBackground: "new 0 0 500 500",
    height: "500px",
    id: "Layer_1",
    viewBox: "0 0 500 500",
    width: "500px",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgQuotes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/quotes.d61a8569.svg";
export { ForwardRef as ReactComponent };